export default "__VITE_ASSET__B56QJpg4__"